import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";


export default class DispatcherDailyWorkflow extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch_Daily_Workflow._name, API.RequestType.READ);
		super(props, model);
	}
	fetchData = async (state) => {
		this.state.limit = 15;
		if (typeof(this.state.filter) === "undefined") {
			this.state.filter = {};
		}
		this.state.filter.selectedUser = this.props.selectedUser ?? null;
		this.state.filter.filterDate = this.props.filterDate ?? moment().format()
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;

		columns = [
			{
				Header: "Dispatcher",
				id: "name",
				accessor: obj => obj.name
			},
			{
				Header: "Activity",
				id: "activity",
				accessor: obj => obj.activity
			},
			{
				Header: "Activity Time",
				id: "time",
				accessor: obj => obj.activity_time
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Daily Workflow', '')}
							{this.renderHeaderRight("Daily Workflow", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
